const LANGUAGE_KEY = 'site-language';

const originalTextMap = new WeakMap();

const phraseMap = {
  'DESIGN THEORY': '设计理论',
  'DIGITAL CREATIVITY': '数字创意',
  'WEB': '网页',
  'INDUSTRIAL DESIGN & VISUAL COMMUNICATION DESIGN': '工业设计与视觉传达设计',
  'ABOUT': '关于',
  'MEDIA': '媒体',
  'RESEARCH / PROJECTS': '研究 / 项目',
  'Photo Credit': '照片来源',
  'OTHER WAYS TO KNOW ME': '更多了解我的方式',
  'Design Research Public Speaking': '设计研究公开演讲',
  'Development technology sharing': '开发技术分享',
  'LEARN MORE': '了解更多',
  'YUQUE DOCUMENT': '语雀文档',
  'All Rights Reserved': '保留所有权利',
  'V-ray rendering: SSS + PBR material': 'V-ray 渲染：SSS + PBR 材质',
  'Literature review of virtual museum': '虚拟博物馆文献综述',
  'Product Creative Design Method': '产品创意设计方法',
  'Prop-based virtual reality storytelling': '道具驱动的虚拟现实叙事',
  'VR cultural exhibition': 'VR 文化展览',
  'VR digital twin': 'VR 数字孪生',
  'AR assisted assembly system': 'AR 辅助装配系统',
  '3Dsmax plugin development for faster rendering and modeling work flow': '用于加速渲染与建模流程的 3Dsmax 插件开发',
  '3D Voxel Art': '3D 体素艺术',
  'Product creativity design tool (WebApp)': '产品创意设计工具（WebApp）',
  'Visualization of knowledge map': '知识图谱可视化',
  'Zhejiang University guide system design': '浙江大学导视系统设计',
  'Visual identity and mascot design': '视觉识别与吉祥物设计',
  'Product design': '产品设计',
  'Environment: V-ray for max.': '环境：V-ray for max。',
  'Qing Gong received the B.S. degree in industrial design from Zhejiang University in 2019, and the Ph.D. degree in design science from the College of Computer Science and Technology, Zhejiang University, in 2024. In 2024, she joined the Yangtze River Delta Innovation Center of Zhejiang University as a postdoctoral researcher. Her research interests include human-computer interaction, and traditional culture and digital creativity.':
    '龚卿于2019年在浙江大学获得工业设计学士学位，并于2024年获浙江大学计算机科学与技术学院设计学博士学位。2024年入职浙江大学长三角创新中心为博士后。她的研究兴趣主要包括人机交互、传统文化数字化与数字创意设计。',
  'Her current research direction is mainly focused on virtual reality, attempting to explore the human-machine interaction issues of virtual reality from the perspectives of engineering and social sciences, in order to achieve the link between virtual reality and design. She attempts to explore and create new concepts in the field of design through new technological applications and empirical research, enhance the influence of the design discipline itself through interdisciplinary integration, and use this as a medium to explore the truth of the world.':
    '她当前的研究方向主要聚焦虚拟现实，尝试从工程与社会科学视角探索虚拟现实中的人机交互问题，以实现虚拟现实与设计之间的连接。她致力于通过新技术应用与实证研究，在设计领域探索并创造新概念，通过跨学科融合提升设计学科自身影响力，并以此为媒介探索世界的本质。',
  'In order to pursue scientific research, she possesses basic design skills, including visual communication, product design, interaction design, etc. At the same time, she read some classic literature on social sciences and mastered some research methods. In addition, she has mastered basic programming skills, including university foundation courses focused on C++, Unity project development based on C #, front-end and back-end separation project development based on VUE3 and Springboot, and hardware development on the Arduino platform.':
    '为开展科研工作，她具备视觉传达、产品设计、交互设计等基础设计能力。同时，她阅读了部分社会科学经典文献并掌握了一些研究方法。此外，她还掌握了基础编程技能，包括以 C++ 为主的大学基础课程、基于 C# 的 Unity 项目开发、基于 VUE3 与 Springboot 的前后端分离项目开发，以及 Arduino 平台的硬件开发。',
  'I was invited to give a speech on design research related topics in "21 Design". "21 Design" is a pure public welfare sharing and exchange platform for design research funded by the Industrial Design Branch of the Chinese Mechanical Engineering Society. It focuses on the most cutting-edge design direction, invites scholars with certain achievements to create and share experiences, and helps young people who are interested in design research to grow together.':
    '我曾受邀在“21 设计”就设计研究相关主题进行演讲。“21 设计”是由中国机械工程学会工业设计分会资助的纯公益设计研究分享与交流平台。该平台聚焦前沿设计方向，邀请具有一定成果的学者进行创作与经验分享，并帮助对设计研究感兴趣的青年共同成长。',
  'I have uploaded some development videos of VR eye-tracking foveated rendering related functions on the personal account of the Bilibili video website, and wrote a development method document on the Yuque platform to share. These have helped other developers and enthusiasts and gained recognition.':
    '我在哔哩哔哩个人账号上传了若干与 VR 眼动追踪注视点渲染相关功能的开发视频，并在语雀平台撰写了开发方法文档进行分享。这些内容帮助了其他开发者与爱好者，并获得了一定认可。'
};

const keywordMap = {
  Research: '研究',
  Projects: '项目',
  Design: '设计',
  Theory: '理论',
  Digital: '数字',
  Creativity: '创意',
  Industrial: '工业',
  Visual: '视觉',
  Communication: '传达',
  Product: '产品',
  Virtual: '虚拟',
  Museum: '博物馆',
  review: '综述',
  storytelling: '叙事',
  cultural: '文化',
  exhibition: '展览',
  twin: '孪生',
  assisted: '辅助',
  assembly: '装配',
  system: '系统',
  rendering: '渲染',
  material: '材质',
  plugin: '插件',
  development: '开发',
  faster: '更快',
  model: '模型',
  workflow: '工作流',
  Voxel: '体素',
  tool: '工具',
  knowledge: '知识',
  map: '图谱',
  guide: '导视',
  mascot: '吉祥物',
  identity: '识别',
  About: '关于',
  Media: '媒体',
  Copyright: '版权'
};

function replaceKeywords(text) {
  let result = text;
  Object.keys(keywordMap).forEach((key) => {
    const re = new RegExp(`\\b${key}\\b`, 'gi');
    result = result.replace(re, keywordMap[key]);
  });
  return result;
}

function translateText(text) {
  const compact = text.replace(/\s+/g, ' ').trim();
  if (!compact) return text;
  const leading = text.match(/^\s*/)[0];
  const trailing = text.match(/\s*$/)[0];
  if (phraseMap[compact]) {
    return `${leading}${phraseMap[compact]}${trailing}`;
  }
  return replaceKeywords(text);
}

function walkTextNodes(root, callback) {
  if (!root) return;
  const stack = [root];
  while (stack.length > 0) {
    const current = stack.pop();
    if (!current) continue;

    if (current.nodeType === 3) {
      callback(current);
      continue;
    }

    if (current.nodeType !== 1) continue;

    const tagName = current.tagName ? current.tagName.toLowerCase() : '';
    if (tagName === 'script' || tagName === 'style') continue;

    for (let i = current.childNodes.length - 1; i >= 0; i -= 1) {
      stack.push(current.childNodes[i]);
    }
  }
}

export function getLanguage() {
  const cached = window.localStorage.getItem(LANGUAGE_KEY);
  if (cached === 'en') return 'en';
  return 'zh';
}

export function setLanguage(lang) {
  const normalized = lang === 'zh' ? 'zh' : 'en';
  window.localStorage.setItem(LANGUAGE_KEY, normalized);
  return normalized;
}

export function applyLanguage(lang) {
  const root = document.getElementById('app');
  if (!root) return;

  if (lang === 'zh') {
    walkTextNodes(root, (node) => {
      const text = node.nodeValue;
      if (!text || !text.trim()) return;
      if (!originalTextMap.has(node)) {
        originalTextMap.set(node, text);
      }
      node.nodeValue = translateText(originalTextMap.get(node));
    });
    return;
  }

  walkTextNodes(root, (node) => {
    if (originalTextMap.has(node)) {
      node.nodeValue = originalTextMap.get(node);
    }
  });
}

